export default function button({ variables }) {
    const isColored = (color) => (props) => props.color === color && props.variant !== "text";
    const transition = "border 0.3s ease, background-color 0.3s ease";
    return {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                variant: "contained",
            },
            styleOverrides: {
                root: () => ({
                    color: variables.text_primary,
                    textTransform: "none",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: variables.border_strong,
                    borderRadius: variables.border_radius_small,
                    transition,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                    "& > .MuiSvgIcon-root": {
                        marginRight: variables.spacing_03,
                        marginLeft: `calc(-1 * ${variables.spacing_02})`,
                    },
                    "&[data-inline]": {
                        height: "auto",
                        minWidth: "auto",
                        padding: `${variables.spacing_01} ${variables.spacing_03}`,
                        "& .MuiSvgIcon-root": {
                            fontSize: variables.icon_size_xs,
                        },
                    },
                    variants: [
                        {
                            props: isColored("primary"),
                            style: {
                                "&:not(:disabled)": {
                                    borderColor: variables.interactive,
                                    backgroundColor: variables.interactive,
                                    color: variables.text_inverse,
                                    "&:hover": {
                                        borderColor: variables.interactive_hover,
                                        backgroundColor: variables.interactive_hover,
                                        color: variables.text_inverse,
                                    },
                                    "&:active": {
                                        backgroundColor: variables.interactive_active,
                                    },
                                },
                            },
                        },
                        {
                            props: isColored("secondary"),
                            style: {
                                "&:not(:disabled)": {
                                    borderColor: variables.border_interactive,
                                    backgroundColor: variables.surface,
                                    color: variables.text_primary,
                                    "&:hover": {
                                        borderColor: variables.border_interactive,
                                        backgroundColor: variables.surface_selected,
                                        color: variables.text_primary,
                                    },
                                    "&:active": {
                                        backgroundColor: variables.surface_selected,
                                    },
                                },
                            },
                        },
                        {
                            props: isColored("error"),
                            style: {
                                "&:not(:disabled)": {
                                    borderColor: variables.feedback_danger,
                                    backgroundColor: variables.surface,
                                    color: variables.feedback_danger,
                                    "&:hover": {
                                        borderColor: variables.feedback_danger,
                                        backgroundColor: variables.feedback_danger,
                                        color: variables.text_inverse,
                                    },
                                    "&:active": {
                                        backgroundColor: variables.feedback_danger_active,
                                    },
                                },
                            },
                        },
                        {
                            props: isColored("nitro"),
                            style: {
                                "&:not(:disabled)": {
                                    "--grad-start": variables.nitro_gradient_start,
                                    "--grad-end": variables.nitro_gradient_end,
                                    border: "none",
                                    background: "linear-gradient(to right, var(--grad-start), var(--grad-end))",
                                    color: variables.text_on_brand,
                                    transition: "--grad-start 0.3s ease, --grad-end 0.3s ease",
                                    "&:hover": {
                                        "--grad-start": variables.nitro_gradient_end,
                                        "--grad-end": variables.nitro_gradient_flip,
                                    },
                                },
                            },
                        },
                        {
                            props: { variant: "text" },
                            style: {
                                border: "none",
                                color: variables.interactive_text,
                                "&:hover": {
                                    backgroundColor: variables.surface_selected,
                                    color: variables.interactive_hover,
                                },
                                "&[data-inline]": {
                                    display: "inline",
                                    padding: `0 ${variables.spacing_01}`,
                                    margin: `0 calc(-1 * ${variables.spacing_01})`,
                                    font: "inherit",
                                    fontWeight: variables.type_button_font_weight,
                                },
                            },
                        },
                        {
                            props: { variant: "text", color: "secondary" },
                            style: {
                                color: variables.text_primary,
                                "&:hover": {
                                    color: variables.text_primary,
                                },
                            },
                        },
                    ],
                }),
                sizeSmall: {
                    height: variables.component_height_small,
                    padding: `${variables.spacing_02} ${variables.spacing_03}`,
                    "& .MuiSvgIcon-root": {
                        fontSize: 16, // size adjustment for icons on small buttons only
                    },
                },
                sizeMedium: {
                    height: variables.component_height_medium,
                    padding: `${variables.spacing_02} ${variables.spacing_05}`,
                },
                sizeLarge: {
                    height: variables.component_height_large,
                    padding: `${variables.spacing_02} ${variables.spacing_06}`,
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    fontSize: variables.type_body_sm_font_size,
                    fontFamily: variables.base_font_family,
                    textAlign: "left",
                    height: "auto",
                    "&.Mui-disabled": {
                        borderColor: variables.border_disabled,
                    },
                },
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
                variant: "contained",
            },
            styleOverrides: {
                root: {
                    "& .MuiButtonGroup-firstButton, & .MuiButtonGroup-middleButton": {
                        borderColor: variables.interactive,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=button.js.map